import { render, staticRenderFns } from "./PayrollPaidLeaves.vue?vue&type=template&id=2889a0a3&scoped=true&"
import script from "./PayrollPaidLeaves.vue?vue&type=script&lang=js&"
export * from "./PayrollPaidLeaves.vue?vue&type=script&lang=js&"
import style0 from "./PayrollPaidLeaves.vue?vue&type=style&index=0&id=2889a0a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889a0a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2889a0a3')) {
      api.createRecord('2889a0a3', component.options)
    } else {
      api.reload('2889a0a3', component.options)
    }
    module.hot.accept("./PayrollPaidLeaves.vue?vue&type=template&id=2889a0a3&scoped=true&", function () {
      api.rerender('2889a0a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollPaidLeaves.vue"
export default component.exports